/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../../../components/Button';
import backImg from '../../../../assets/images/Fireboard/back_arrow_white.png';
import undoWhiteImg from '../../../../assets/images/Fireboard/undo-white.png';
import searchImg from '../../../../assets/images/Fireboard/searchwhite.png';
import strings from '../../../../globalization';
import classes from './Header.module.css';

const Header = ({
  goBack,
  showBack,
  isPickedUpUndoEnabled,
  undoPickedUp,
  sortByName,
  ascending,
  showClosedChecks,
  onToggleSwitch,
  onToggleSearchInput,
}) => {
  return (
    <div className={classes.headerContainer}>
      {showBack && (
        <Button className={classes.button} onClick={goBack}>
          <img src={backImg} className={classes.backImg} alt='back' />
          <span className={classes.buttonText}>{strings.goToFireboard}</span>
        </Button>
      )}
      <span className={classes.onedine}>{strings.onedineLable}</span>
      <Button disabled={!isPickedUpUndoEnabled} className={classes.undoButton} onClick={undoPickedUp}>
        <img src={undoWhiteImg} className={classes.undoImg} alt='undo' />
      </Button>
      <Button className={classes.searchBtn} onClick={() => onToggleSearchInput(true)}>
        <img src={searchImg} className={classes.undoImg} alt='search' />
      </Button>
      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>{strings.sortByName}</span>
        <div className={classes.toggleContainer} onClick={() => onToggleSwitch('sortByName')}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: sortByName })} />
        </div>
        <span className={classes.sortByTimeTxt}>{strings.sortByTime}</span>
      </div>
      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>{strings.ascCaps}</span>
        <div className={classes.toggleContainer} onClick={() => onToggleSwitch('ascending')}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: ascending })} />
        </div>
        <span className={classes.sortByTimeTxt}>{strings.descCaps}</span>
      </div>
      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>{strings.closed}</span>
        <div className={classes.toggleContainer} onClick={() => onToggleSwitch('showClosedChecks')}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: showClosedChecks })} />
        </div>
        <span className={classes.sortByTimeTxt}>{strings.allLabel}</span>
      </div>
    </div>
  );
}

export default Header;

Header.propTypes = {
  goBack: PropTypes.func.isRequired,
  showBack: PropTypes.bool,
  isPickedUpUndoEnabled: PropTypes.bool,
  undoPickedUp: PropTypes.func,
  sortByName: PropTypes.bool,
  ascending: PropTypes.bool,
  onToggleSwitch: PropTypes.func,
  showClosedChecks: PropTypes.bool,
  onToggleSearchInput: PropTypes.func,
};

Header.defaultProps = {
  goBack: () => { },
  showBack: false,
  isPickedUpUndoEnabled: false,
  undoPickedUp: () => { },
  sortByName: false,
  ascending: true,
  onToggleSwitch: () => { },
  showClosedChecks: true,
  onToggleSearchInput: () => { },
};
